import { useEffect } from 'react';

export const useGroupToDeleteUrlParam = ({
    searchGroupAlreadyExists,
    searchGroupIdToDelete,
    redirectToDefaultAddress,
    setModalVisibility,
}) => {
    useEffect(() => {
        if (Boolean(searchGroupIdToDelete) && !searchGroupAlreadyExists) {
            return redirectToDefaultAddress();
        }
        setModalVisibility(Boolean(searchGroupIdToDelete));
    }, []);
};
